<template>
    <el-select
        v-model="innerValue"
        filterable
        @change="langChange"
        :placeholder="placeholder || props.placeholder"
        :disabled="disabled || false"
        v-bind="props"
    >
        <el-option v-for="item in options" :key="item.value" :label="$t(item.i18nKey)" :value="item.value"></el-option>
    </el-select>
</template>

<script>
import { businessLangs } from "./languages.js";

const langOptions = requireAll => {
    let langs = businessLangs().map(lang => {
        return {
            value: lang.lang,
            i18nKey: lang.i18nKey
        };
    });

    if (requireAll) {
        langs = [
            {
                value: "all",
                i18nKey: "zhiji.common.allLanguage"
            }
        ].concat(langs);
    }

    return [...langs];
};

export default {
    name: "LangSelect",
    // requireAll: true 含"所有语言"选项
    props: ["value", "placeholder", "requireAll", "widget", "disabled"],
    model: {
        props: "value",
        event: "change"
    },
    data() {
        return {
            innerValue: this.value
        };
    },
    computed: {
        options() {
            return langOptions(this.requireAll);
        },
        props() {
            return this.widget ? this.widget.props : {}
        }
    },
    methods: {
        langChange(value) {
            this.$emit("change", value);
        }
    },
    watch: {
        value(val) {
            this.innerValue = val;
        }
    }
};
</script>
